import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

// ✅ className 병합 유틸
export function cn(...inputs) {
  return twMerge(clsx(inputs))
}
